"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";

function ArchiveHeaderContent() {
  const { links, loading, error } = useShopBreadcrumbs();

  if (loading) {
    return (
      <div className="flex flex-col gap-4 animate-pulse py-4">
        <div className="h-5 w-48 rounded-md bg-muted"></div>
        <div className="mt-2 h-10 w-64 rounded-md bg-muted"></div>
      </div>
    );
  }

  if (error || links.length === 0) {
    return (
      <div className="flex flex-col gap-4 py-4">
        <h1 className="font-default text-primary text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
          Our Floral Collection
        </h1>
      </div>
    );
  }

  const lastIndex = links.length - 1;
  const currentTitle = links[lastIndex].title;

  return (
    <div className="flex flex-col gap-4 py-4">
      <Breadcrumb>
        <BreadcrumbList>
          {links.map((link, index) => (
            <React.Fragment key={link.href}>
              <BreadcrumbItem data-index={index}>
                {index === lastIndex ? (
                  <BreadcrumbPage className="text-primary font-medium">{link.title}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild className="text-muted-foreground hover:text-primary transition-colors">
                    <Link to={link.href}>{link.title}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {index < lastIndex && <BreadcrumbSeparator className="text-muted-foreground" />}
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>

      <h1 className="font-default mt-2 text-primary text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
        {currentTitle}
      </h1>
    </div>
  );
}

export default function ArchiveTitle() {
  return (
    <section data-section-id="240908"
      id="archive-title"
      className="bg-background text-foreground border-b border-border py-8 md:py-12"
    >
      <div className="container mx-auto px-4 md:px-6">
        <ShopBreadcrumbsProvider>
          <ArchiveHeaderContent />
        </ShopBreadcrumbsProvider>
      </div>
    </section>
  );
}